import { render, staticRenderFns } from "./devlist.vue?vue&type=template&id=a2355dc6&scoped=true"
import script from "./devlist.vue?vue&type=script&lang=js"
export * from "./devlist.vue?vue&type=script&lang=js"
import style0 from "./devlist.vue?vue&type=style&index=0&id=a2355dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2355dc6",
  null
  
)

export default component.exports